<template>
  <div class="directory-card" data-test-directory-card>
    <header>
      <adn-image
        v-if="imageUrl"
        class="directory-card__image"
        :source="imageUrl"
        :alt="imageAlt"
        :loading="index < 4 ? 'eager' : 'lazy'"
      />
      <div v-if="imageOverlay" class="directory-card__image--overlay"></div>
      <div class="directory-card__title">
        <h2>{{ title }}</h2>
        <legend v-if="numberFilesLabel || formattedDate" :class="{ 'align-right': !numberFilesLabel }">
          <small v-if="numberFilesLabel">
            <i class="adn-icon adn-icon--category-news"></i>
            {{ numberFilesLabel }}
          </small>
          <small v-if="formattedDate">
            <i class="adn-icon adn-icon--function-calendar"></i>
            {{ formattedDate }}
          </small>
        </legend>
      </div>
    </header>
    <p>{{ description }}</p>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import AdnImage from '../AdnImage/AdnImage.vue'

export default defineComponent({
  name: 'IdfDirectoryCard',
  components: { AdnImage },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      required: true,
    },
    imageAlt: {
      type: String,
      default: '',
    },
    imageOverlay: {
      type: Boolean,
      default: true,
    },
    formattedDate: String,
    numberFilesLabel: String,
    index: {
      type: Number,
      default: 0,
    },
  },
})
</script>

<style scoped lang="scss">
.directory-card {
  .adn-icon {
    margin-right: var(--spacing-2);
  }

  header {
    position: relative;
  }

  .directory-card__image {
    border-radius: var(--border-radius-3);
    object-fit: cover;
    object-position: center;
    max-height: 24rem;
    width: 100%;
  }

  .directory-card__image--overlay {
    position: absolute;
    border-radius: var(--border-radius-3);
    max-height: 24rem;
    inset: 25% 0 0;
    background: linear-gradient(180deg, rgb(20 20 20 / 0%) 0%, rgb(20 20 20 / 80%) 100%);
  }

  .directory-card__title {
    color: var(--color-white);
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 100%;
    padding: var(--spacing-3);
    position: absolute;
    top: 0;
    width: 100%;

    > h2::first-letter {
      text-transform: capitalize;
    }

    legend {
      display: flex;
      justify-content: space-between;
      margin: 0;

      small {
        align-items: center;
        display: flex;
        font-size: var(--font-size-xs);
      }
    }

    legend.align-right {
      justify-content: flex-end;
    }
  }

  p {
    margin: var(--spacing-2);
    text-align: justify;
  }
}
</style>
